import { cva } from 'class-variance-authority';

/**
 * Status pill.
 *
 * Every tone keeps the same surface and border and differs only in the text
 * token. That is deliberate: the difference a user actually reads is the word,
 * and the colour confirms it. A colour-only design would make the badge a
 * status indicator for people who cannot use one.
 */
export const badgeStyles = cva(
  [
    'inline-flex w-fit items-center gap-1 rounded-control border',
    'px-2 py-0.5 text-xs font-medium leading-normal',
  ],
  {
    variants: {
      tone: {
        neutral: 'border-border bg-surface-sunken text-content-muted',
        info: 'border-border bg-surface-sunken text-accent',
        positive: 'border-border bg-surface-sunken text-positive',
        caution: 'border-border bg-surface-sunken text-caution',
        critical: 'border-border bg-surface-sunken text-critical',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  },
);

export const badgeIconStyles = 'size-3 shrink-0';